import styles from "./ContentHeader.module.css"
const ContentHeader = (props) => {
  return (
      <div className={styles.content_header}>
          {props.children}
    </div>
  )
}

export default ContentHeader